import { BackToClinicButton } from "@components/BackToClinicButton";
import { CompanionControls } from "@components/CompanionControls";

type CompanionHeaderProps = {
  /** The back-to-clinic button's test id and the route title beside it. */
  back: { title: string; testId: string };
};

/**
 * The header band for the outer routes (Calendar, Tasks, Admin, Replay): a
 * back-to-clinic button and the route title, plus the shared `CompanionControls`
 * cluster.
 *
 * The clinic workspace does NOT use this — it renders `CompanionControls` inside
 * its rail column so the content window runs full height. That's why `back` is
 * required here: every route that still wants a band also wants a way out of it.
 *
 * The band is the desk showing above the route's page, which is what makes the
 * control cluster's one treatment honest: it writes in `text-ink-inverse` here and
 * in the workspace rail alike, so nothing reads a theme to decide. Routes keep
 * their own page surface below the band.
 */
export const CompanionHeader = ({ back }: CompanionHeaderProps) => (
  <header className="flex shrink-0 items-center gap-4 bg-desk px-6 font-body text-ink-inverse">
    <BackToClinicButton dataTestId={back.testId} />
    <div className="min-w-0 truncate font-display text-lg font-medium">
      {back.title}
    </div>
    <div className="ml-auto min-w-0">
      <CompanionControls />
    </div>
  </header>
);
